import { Table, TableContainer } from '@mui/material';

const styles = {
  tableContainer: {
    boxShadow: 'none',
    flex: 1,
  },
  table: {
    tableLayout: 'fixed' as const,
  },
};

export const ComponentTable = ({ children }: { children: React.ReactNode }) => (
  <TableContainer sx={styles.tableContainer}>
    <Table sx={styles.table}>{children}</Table>
  </TableContainer>
);
